import {createSelector} from 'reselect';

export const getApplicationData = (state) => state.applicationData || {};
export const getApplicationDataIsLoaded = createSelector(
  getApplicationData,
  (applicationData) => applicationData.isLoaded
);
export const getApplicationConfigData = createSelector(
  getApplicationData,
  (applicationData) => applicationData.data
);
export const getApplicationDataHasFailed = createSelector(
  getApplicationData,
  (applicationData) => applicationData.hasFailed
);

export const getApplicationDataIsLoading = createSelector(
  getApplicationData,
  (applicationData) => applicationData.isLoading
);

export const getCurrentStep = createSelector(
  getApplicationData,
  (applicationData) => applicationData.currentStep
);